module.exports = __webpack_public_path__ + "img/inseetrading-laodl-800x800.906c593a.jpg";